import { useState } from "react";
import { Colors } from "../Assets/Config/color.config";
import "../config"
import { backgroundTheme, colorTheme } from "../Style/ColorTheme/colorTheme";

const color_Theme = colorTheme();

export const MyButton = (props) => {
  const {
    text,
    count,
    textAlign,
    onClick,
    type,
    style,
    small,
    normal,
    disabled,
    leftIcon,
    rightIcon,
    id,
    custom,
    // noShadow,
    customcolor,
    customHoverColor,
    dataToggle,
    dataTarget,
    dataDismiss,
    className,
    title,
    noTxtLight,
    theme,
    textColor,
    border,
    textcolor,
    width
  } = props;
  // console.log("no text light",noTxtLight)
  const [isHover, setIsHover] = useState(true);

  const defaultStyle1 = {
    background: customcolor || Colors.lightBlue,
    // opacity: 0.8,
  };
  // 
  const hoverStyle = {
    background: customHoverColor || customcolor || Colors.lightBlue,
    opacity: 1,
    // boxShadow: noShadow?'none':`0px 2px 3px ${customcolor||Color.SoftBlue}`
  };

  const defaultStyle = isHover || disabled ? defaultStyle1 : hoverStyle;

  const userStyle = style === undefined ? {} : style;

  return (
    <button
      data-dismiss={dataDismiss}
      data-bs-dismiss={dataDismiss}
      disabled={disabled}
      data-target={dataTarget}
      data-bs-target={dataTarget}
      data-toggle={dataToggle}
      data-bs-toggle={dataToggle}
      id={id}
      onClick={onClick}
      type={type === undefined ? "button" : type}
      // border={border ?? 'none'}
      // className={`btn btn-block rounded ${noTxtLight ? "" : "text-light"} ${textAlign ? textAlign : "text-center"} 
      className={`btn btn-block rounded ${textAlign ? textAlign : "text-center"} 
      ${small ? "p-1" : normal ? 'p-0' : custom ? "" : "p-2"
        } 
        ${className}`}
      style={{
        ...defaultStyle,
        ...userStyle,
        outline: "none",
        boxShadow: "none",
        transition: ".5s",
        padding:custom ? "6px 15px" : 0,
        border:border ?? 'none',
        color: textcolor ? textcolor : color_Theme.buttonText,
        fontFamily: color_Theme.fontFamily,
        fontSize:"16px",
        // width: width ?? "75px",
        borderRadius:"6px",
        textTransform:"none"
      }}
      title={disabled ? title : ""}
      onMouseOver={() => setIsHover(false)}
      onMouseLeave={() => setIsHover(true)}
    >
      {/* <div style={{color:textColor ?? 'white',display:'flex',justifyContent:'center',alignItems:'center'}}> */}
      {leftIcon ? <span className="" style={{margin:'0px 5px'}}> {leftIcon} </span> : null}
      {text}
      {/* <div style={{color:textColor}}>
        {text}
      </div> */}
      {
        count > 0 && (
          <span style={{ marginLeft:"5px",backgroundColor: theme == "dark" ? "#1161d5" : Colors.dark.secBorderColor, fontSize: 13,padding:"5px" }} className="badge badge-primary">{count}</span>
        )
      }
      {rightIcon ? <span className="" style={{margin:'0px 5px'}}> {rightIcon} </span> : null}
      {/* </div> */}
    </button>
  );
};
